<template lang="pug">
v-list-tile.base-text-divider
  v-divider
  .subheading.px-3 
    slot
  v-divider
</template>

<script>
export default {
  name: "BaseTextDivider"
};
</script>
